<div *ngIf="jbType === 'list'" class="list-unstyled">
  <li *ngFor="let fakeRow of fakeRows" class="list-row list-row-placeholder">
    <div *ngFor="let fakeCol of fakeRow.fakeCols"
         class="fake-row-placeholder"
         [ngClass]="fakeCol.colClass">
      <h5 class="placeholder-text"></h5>
    </div>
  </li>
</div>


<div *ngIf="jbType === 'table'">
  <div class="row">
    <div class="col-12">
      <!-- <div class="overlay-text"><h4>Loading</h4></div> -->

      <ul class="list-unstyled table-list">
        <li class="list-header"></li>
        <li *ngFor="let fakeRow of fakeRows" class="list-row">
          <div *ngFor="let fakeCol of fakeRow.fakeCols" class="fake-row-placeholder" [ngClass]="fakeCol.colClass">
            <h5 class="placeholder-text"></h5>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<div *ngIf="jbType === 'tile'" class="fake-tile-placeholder"></div>

<div *ngIf="jbType === 'cards'" class="fake-cards-list list-unstyled">
  <div *ngFor="let fakeCard of fakeRows" class="card-wrapper">
    <div class="card-placeholder">
    <div class="upper-image"></div>
    <div class="upper-button"></div>
    <div class="upper-line1"></div>
    <div class="upper-line2"></div>
    <div class="upper-line3"></div>
    <div class="upper-line4"></div>
    <div class="upper-line5"></div>
    <div class="mid"></div>
    <div class="bottom-line1"></div>
    <div class="bottom-line2"></div>
    <div class="bottom-line3"></div>
    </div>
  </div>
</div>
